"use client";

import { ArrowUp, GitCompare, TicketIcon } from "lucide-react";
import { SetStateAction } from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { useAppDispatch } from "@/redux/hooks";

import { BulkActionsToolbar } from "@/components/bulk-actions-toolbar";
import { resetSelectedFlight } from "@/feature/flight/search/state/slices/flight-data.slice";
import { IFlight } from "@/feature/flight/search/types/flight";

interface ISelectFlight {
  expireTime?: string;
  data: IFlight[];
}

export default function FlightBulkActionsToolbar({
  setShowOnlySelected,
  selectFlight,
  showOnlySelected,
}: {
  setShowOnlySelected: (value: SetStateAction<boolean>) => void;
  showOnlySelected: boolean;
  selectFlight: ISelectFlight;
}) {
  const dispatch = useAppDispatch();

  return (
    <>
      <BulkActionsToolbar
        entityName="flight"
        selectedCount={selectFlight.data.length}
        onClear={() => {
          dispatch(resetSelectedFlight());
          setShowOnlySelected(false);
        }}
      >
        {/* Show Selected / Show All */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowOnlySelected(!showOnlySelected)}
              className="group gap-1"
            >
              {showOnlySelected ? (
                <ArrowUp className="h-4 w-4" />
              ) : (
                <TicketIcon className="h-4 w-4" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent className="animate-in fade-in zoom-in-95 duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0">
            {showOnlySelected
              ? "Show all flights"
              : "Show only selected flights"}
          </TooltipContent>
        </Tooltip>

        {/* Wrapper is interactive for tooltip */}
        <span className="inline-flex">
          <Button
            name="compare_flights"
            disabled={selectFlight.data.length < 2}
            variant="outline"
            size="sm"
            className="group gap-1 disabled:pointer-events-none"
          >
            <GitCompare className="h-4 w-4" />
            {/* Smooth text reveal */}
            <span className=" max-w-0 overflow-hidden opacity-0 transition-all duration-300 ease-in-out  group-hover:max-w-xs group-hover:opacity-100">
              Compare
            </span>
          </Button>
        </span>
      </BulkActionsToolbar>
    </>
  );
}
